"use client";

import { useEffect, useState } from "react";

/** Card/bottom-nav layout below this; table/sidebar from 912px mockups up. */
export const FINANCIAL_WORK_DESKTOP_MIN_PX = 900;

/** Icon-rail + horizontal งานเงิน/ข้อมูล until this; full left nav from 1440 mockup. */
export const FINANCIAL_WORK_WIDE_RAIL_MIN_PX = 1440;

/** Mobile งานเงิน scroll column — keep in sync with preparing cover padding. */
export const FINANCIAL_WORK_MOBILE_SCROLL_CLASS =
  "flex min-h-0 min-w-0 flex-1 flex-col overflow-y-auto px-4 py-3 sm:px-4 sm:py-4";

/** Desktop (≥900) work column — padding lives on overview / list sections. */
export const FINANCIAL_WORK_DESKTOP_SCROLL_CLASS =
  "flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden";

function useMinWidth(px: number) {
  const [matches, setMatches] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia(`(min-width: ${px}px)`).matches
      : false,
  );

  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${px}px)`);
    const update = () => setMatches(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, [px]);

  return matches;
}

export function useFinancialWorkDesktop() {
  return useMinWidth(FINANCIAL_WORK_DESKTOP_MIN_PX);
}

export function useFinancialWorkWideRail() {
  return useMinWidth(FINANCIAL_WORK_WIDE_RAIL_MIN_PX);
}
